<template>
  <!-- v-if="section.seatLayout" -->
  <div
    :class="
      fullscreen
        ? 'pos-seatlayout-wrapper-fullscreen'
        : 'pos-seatlayout-wrapper overflow-hidden'
    "
  >
    <header class="pos-seatlayout-header">
      <div class="row">
        <div class="col-7 align-self-center d-flex" style="gap:10px">
          <strong class="fs-22">{{ getScreenPosNames }}</strong>
          <div class="d-flex">
            <button @click="pluszoom('plus')" class="plus-btn mx-2">+</button>
            <button @click="pluszoom('minus')" class="plus-btn">-</button>
          </div>
          <div class="text-right">
            <button class="btn-blue" v-b-modal.specify_seats_modal>
              View Pricing
            </button>
          </div>
        </div>
        <div class="zoom-section"></div>

        <div class="col-5 align-self-center">
          <div class="d-flex align-items-center w-100 justify-content-end">
            <button class="btn-transparent" v-on:click="showFullScreenFunc()">
              <img
                width="30"
                height="30"
                src="@/assets/img/icons/fullscreen-icon.svg"
              />
              <!-- <small v-if="!fullscreen">{{ $t('full') }} {{ $tc('screen', 2) }}</small>
              <small v-if="fullscreen">{{ $t('exit') }} {{ $t('full') }} {{ $tc('screen', 2) }}</small>-->
            </button>

            <div class="d-flex align-items-center border-left pl-3 mx-2">
              <b-form-checkbox
                v-model="isMultiSelectAllowed"
                class="j-checkbox pb-0"
                @change="onChangeMultiSelectSeats($event)"
              />
              <span class="mb-0">Multiselect</span>
            </div>

            <button
              class="btn-transparent"
              @click="showSeatNames = !showSeatNames"
            >
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 25C9.16119 25 6.02207 23.6998 3.66116 21.3388C1.30024 18.9779 0 15.8388 0 12.5C0 9.16119 1.30024 6.02207 3.66116 3.66116C6.02207 1.30024 9.16119 0 12.5 0C15.8388 0 18.9779 1.30024 21.3388 3.66116C23.6998 6.02207 25 9.16119 25 12.5C25 15.8388 23.6998 18.9779 21.3388 21.3388C18.9779 23.6998 15.8388 25 12.5 25ZM12.5 1.95312C6.68449 1.95312 1.95312 6.68449 1.95312 12.5C1.95312 18.3155 6.68449 23.0469 12.5 23.0469C18.3155 23.0469 23.0469 18.3155 23.0469 12.5C23.0469 6.68449 18.3155 1.95312 12.5 1.95312ZM19.2522 10.8398L17.8711 9.45873L12.5 14.8298L7.12891 9.45873L5.7478 10.8398L12.5 17.592L19.2522 10.8398Z"
                  fill="#404040"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <b-collapse v-model="showSeatNames">
        <div class="row mx-0 pt-3 justify-content-between">
          <div
            class="d-flex justify-content-end align-items-center"
            style="text-align: center;"
          >
            <div class="mx-1 height_cutsom">
              <div
                class="
                  pos-seat
                  my-0
                  regular-seat
                  seat-fixed-width
                  mx-auto
                  bg-blue
                "
              ></div>
              <span style="font-size:12px">Regular {{ $tc("seat", 1) }}</span>
            </div>

            <div
              class="mx-1 height_cutsom"
              style="position: relative; top: 2px"
            >
              <div class="text-center mb-1">
                <img
                  src="@/assets/img/pos/wheelchair.svg"
                  height="auto"
                  width="22"
                  alt
                />
              </div>
              <span style="font-size:12px">{{ $t("wheelchair") }}</span>
            </div>

            <div class="mx-1 height_cutsom">
              <div
                class="pos-seat my-0 vip-seat seat-fixed-width mx-auto bg-blue"
              ></div>
              <span style="font-size:12px">VIP {{ $tc("seat", 1) }}</span>
            </div>

            <!-- <div class="mx-1">
            <div class="pos-seat my-0 love-seat mx-auto bg-blue"></div>
            <span style="font-size:12px">{{ $t('love') }} {{ $tc('seat', 1) }}</span style="font-size:12px">
            </div>-->

            <div
              class="mx-1 height_cutsom"
              style="position: relative; top: 2px"
            >
              <!-- <div class="text-center mb-1">
              <img src="@/assets/img/icons/pointofsale.png" height="auto" width="22" alt />
              </div>-->
              <div class="pos-seat my-0 pointofsale-seat mx-auto bg-blue"></div>
              <span style="font-size:12px">{{ $t("onlyPos") }}</span>
            </div>

            <div class="mx-1 height_cutsom">
              <div
                class="pos-seat my-0 sofa-seat seat-fixed-width mx-auto bg-blue"
              ></div>
              <span style="font-size:12px">{{ $tc("Sofa", 1) }}</span>
            </div>

            <div class="mx-1 height_cutsom">
              <div
                class="
                  pos-seat
                  my-0
                  recliner-seat
                  seat-fixed-width
                  mx-auto
                  bg-blue
                "
              ></div>
              <span style="font-size:12px"
                >{{ $t("recliner") }} {{ $tc("seat", 1) }}</span
              >
            </div>

            <div class="mx-1 height_cutsom">
              <div
                class="pos-seat my-0 block-seat seat-fixed-width mx-auto"
              ></div>
              <span style="font-size:12px">{{ $tc("blockSeat", 1) }}</span>
            </div>

            <div
              class="mx-1 height_cutsom"
              style="position: relative; top: 2px"
            >
              <!-- <div class="text-center mb-1">
              <img src="@/assets/img/icons/broken-seat.jpg" height="auto" width="22" alt />
              </div>-->
              <div
                class="
                  pos-seat
                  my-0
                  broken-seat
                  seat-fixed-width
                  mx-auto
                  bg-blue
                "
              ></div>
              <span style="font-size:12px"
                >{{ $t("broken") }} {{ $tc("seat", 1) }}</span
              >
            </div>

            <div class="divider mx-1 height_cutsom"></div>

            <div class="mx-1 height_cutsom">
              <div class="pos-seat my-0 taken seat-fixed-width mx-auto"></div>
              <span style="font-size:12px">{{ $t("taken") }}</span>
            </div>

            <div class="mx-1 height_cutsom">
              <div
                class="pos-seat my-0 your-selection seat-fixed-width mx-auto"
              ></div>
              <span style="font-size:12px"
                >{{ $t("your") }} {{ $t("selection") }}</span
              >
            </div>
          </div>
        </div>
      </b-collapse>

      <div class="row pt-3 " v-if="isMultiSelectAllowed">
        <!-- <div class="col-2 align-self-center">
          <h6 class="text-blue mb-0">Select no of seats:</h6>
        </div> -->
        <div class="col-12 px-0">
          <ul
            class="seatNumList list-inline pl-0 mb-0 justify-content-center d-flex"
          >
            <li
              class="list-inline-item "
              :class="totalNumberOfSeats == item ? 'active' : ''"
              @click="onSelectNumberOfSeats(item)"
              v-for="(item, itemKey) in selectSeatPopUpCount"
              :key="itemKey"
            >
              {{ itemKey + 1 }}
            </li>
          </ul>
        </div>
      </div>
    </header>

    <div
      :class="[
        'pos-seatlayout',
        ,
        isMultiSelectAllowed ? 'multiseat-is-active' : null,
        showSeatNames ? 'seatname-is-active' : null,
        reverse ? 'pos-seatlayout-rotate notransition' : null,
      ]"
      :style="`zoom:${numzoom}`"
      v-on:wheel.up="onmouseScroll($event)"
    >
      <table
        v-for="(seat, seatIndex) in seatType"
        :key="seatIndex"
        :class="isDblClick ? 'large' : null"
        @dblclick="dblClick()"
      >
        <tr>
          <td colspan="30">
            <div
              class="relative mb-3"
              v-bind:class="{ hideScreen: seatIndex != 0 }"
            >
              <img
                src="@/assets/img/pos/pos-screen.png"
                class="img-fluid w-100"
              />
              <span
                class="eyes-text"
                :class="reverse ? 'pos-seatlayout-rotate-text' : ''"
                >{{ $t("screen_title") }}</span
              >
            </div>
          </td>
        </tr>
        <!-- REGULAR SEATS -->

        <!-- SLIVER CLASS LABEL -->

        <tr v-if="!isWheelChairOnlyRow(seat.seatsFinal)">
          <td colspan="30">
            <!-- seatTypetext -->
            <div class="relative text-uppercase">
              <span class="seatTypetext">
                {{ seat.seatType }}
                ({{ currFormat(seat.seat_price) }} {{ currencyData.curr_code }})
              </span>
            </div>
          </td>
        </tr>

        <!--3rd-->

        <tr
          v-for="(seatRow, seatRowIndex) in seat.seatsFinal"
          :key="seatRowIndex"
        >
          <!-- <td> -->
          <!-- <div class="text-center lh-1">{{seatRowIndex}}</div> -->
          <!-- </td> -->
          <!-- <td>
            <div class="pos-seatNumber">1</div>
            <div v-on:click="onClickSeatFunc()" class="pos-seat regular-seat your-selection"></div>
          </td>-->
          <!-- <td>
            <div class="pos-seatNumber">2</div>
            <div v-on:click="onClickSeatFunc()" class="pos-seat regular-seat your-selection"></div>
          </td>-->
          <!-- Commented hardcoded below seat name(Said by sanath) -->
          <!-- <td v-bind:class="{ hideScreen: seatIndex != 0 }">
            <div class="text-center pt-3">A1</div>
          </td>-->
          <div style="font-weight:bold;">
            {{
              getSafe(
                () =>
                  seatRow.filter((r) => !!r.sl_seat_name)[0].sl_seat_name[0],
                " "
              )
            }}
          </div>
          <td
            v-for="(singleSeat, singleSeatIndex) in seatRow"
            :key="'index' + singleSeatIndex"
            :class="
              singleSeat.sst_seat_type.toLowerCase() == 'sofa'
                ? 'lounger-container_no_use' //SOFA is a old code we are not using this anymore we have created it dynamic
                : ''
            "
          >
            <!-- {{singleSeat.seat_reserve_type_id}} -->
            <div
              v-if="singleSeat.covidBlocked || singleSeat.covidBlockedTemp"
              v-on:click="
                onClickSeat(
                  singleSeat,
                  seatRowIndex,
                  singleSeatIndex,
                  null,
                  null,
                  $event,
                  seatIndex
                )
              "
              class="text-center"
            >
              <CovidBlockedSeatIcon :active="singleSeat.selectStatus == true" />
            </div>
            <div
              v-else-if="singleSeat.seat_reserve_type_id == 5"
              class="pos-seat cursor-pointer"
              :style="{
                borderColor:
                  singleSeat.selectStatus == true
                    ? '#01d04a !important'
                    : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                        .sst_seat_color_code + ' !important',
                backgroundColor:
                  singleSeat.selectStatus == true
                    ? ''
                    : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                        .sst_seat_color_code + ' !important',
              }"
              v-on:click="
                onClickSeat(
                  singleSeat,
                  seatRowIndex,
                  singleSeatIndex,
                  null,
                  null,
                  $event,
                  seatIndex
                )
              "
              :class="
                singleSeat.isVipReserved
                  ? 'reserved-seat taken pointer-events'
                  : singleSeat.srt_id == 2
                  ? 'normal-seat pointer-events'
                  : singleSeat.seat_reserve_type_id == 8
                  ? 'pointer-events'
                  : singleSeat.seat_reserve_type_id == 13
                  ? 'pointer-events'
                  : ''
              "
            >
              <img :src="getSeatIconURL(singleSeat)" height="28" width="28" />
            </div>
            <div
              :style="{
                borderColor:
                  singleSeat.selectStatus == true
                    ? '#01d04a !important'
                    : singleSeat.seat_reserve_type_id == 8
                    ? ''
                    : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                        .sst_seat_color_code + ' !important',
                backgroundColor:
                  singleSeat.selectStatus == true
                    ? ''
                    : singleSeat.seat_reserve_type_id == 8
                    ? ''
                    : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                        .sst_seat_color_code + ' !important',
              }"
              v-else
              v-on:click="
                onClickSeat(
                  singleSeat,
                  seatRowIndex,
                  singleSeatIndex,
                  null,
                  null,
                  $event,
                  seatIndex
                )
              "
              class="pos-seat cursor-pointer"
              :class="
                singleSeat.isVipReserved
                  ? 'reserved-seat taken pointer-events'
                  : singleSeat.srt_id == 2
                  ? 'normal-seat pointer-events'
                  : singleSeat.seat_reserve_type_id == 8
                  ? 'pointer-events'
                  : singleSeat.seat_reserve_type_id == 13
                  ? 'pointer-events'
                  : ''
              "
            >
              <img :src="getSeatIconURL(singleSeat)" height="28" width="28" />
            </div>
            <div
              v-if="singleSeat.srt_id == 2"
              class="pos-seatNumber pt-1"
            ></div>
            <div v-else class="pos-seatNumber pt-1">
              {{ singleSeat.sl_seat_name }}
            </div>
          </td>
          <!-- <td>
            <div class="text-center lh-1">{{seatRowIndex}}</div>
          </td>-->
        </tr>

        <!-- <tr v-for="(loop , regularSeatsRow) in 3" :key="regularSeatsRow">
          <td>
            <div v-if="regularSeatsRow == 0" class="text-center lh-1">A</div>
            <div v-if="regularSeatsRow == 1" class="text-center lh-1">B</div>
            <div v-if="regularSeatsRow == 2" class="text-center lh-1">C</div>
          </td>
          <td v-for="(loop , regularSeats) in 20" :key="regularSeats">
            <div class="pos-seatNumber">{{regularSeats}}</div>
            <div v-on:click="onClickSeat()" class="pos-seat regular-seat"></div>
          </td>
          <td>
            <div v-if="regularSeatsRow == 0" class="text-center lh-1">A</div>
            <div v-if="regularSeatsRow == 1" class="text-center lh-1">B</div>
            <div v-if="regularSeatsRow == 2" class="text-center lh-1">C</div>
          </td>
        </tr>-->

        <!-- GOLD CLASS LABEL-->
        <!-- <tr>
          <td colspan="22">
            <div class="pos-seat-class">
              Gold Class
              <strong>(300 AED)</strong>
            </div>
          </td>
        </tr>-->

        <!-- <tr v-for="(loop , vipSeatsRow) in 3" :key="vipSeatsRow">
          <td>
            <div v-if="vipSeatsRow == 0" class="text-center lh-1">D</div>
            <div v-if="vipSeatsRow == 1" class="text-center lh-1">E</div>
            <div v-if="vipSeatsRow == 2" class="text-center lh-1">F</div>
          </td>
          <td>
            <div class="pos-seatNumber">0</div>
            <div class="pos-seat wheelchair"></div>
          </td>
          <td v-for="(loop , vipSeatKey) in 19" :key="vipSeatKey">
            <div class="pos-seatNumber">{{vipSeatKey}}</div>
            <div class="pos-seat vip-seat"></div>
          </td>
          <td>
            <div v-if="vipSeatsRow == 0" class="text-center lh-1">D</div>
            <div v-if="vipSeatsRow == 1" class="text-center lh-1">E</div>
            <div v-if="vipSeatsRow == 2" class="text-center lh-1">F</div>
          </td>
        </tr>-->

        <!-- RECLINER CLASS LABEL-->
        <!-- <tr>
          <td colspan="22">
            <div class="pos-seat-class">
              Recliner Class
              <strong>(500 AED)</strong>
            </div>
          </td>
        </tr>-->

        <!-- <tr v-for="(loop , recliner) in 2" :key="recliner">
          <td>
            <div v-if="recliner == 0" class="text-center lh-1">G</div>
            <div v-if="recliner == 1" class="text-center lh-1">H</div>
          </td>
          <td colspan="2" v-for="(loop , loveSeatKey) in 10" :key="loveSeatKey">
            <div class="pos-seatNumber">{{loveSeatKey}}</div>
            <div class="pos-seat love-seat"></div>
          </td>
          <td>
            <div v-if="recliner == 0" class="text-center lh-1">G</div>
            <div v-if="recliner == 1" class="text-center lh-1">H</div>
          </td>
        </tr>-->
      </table>

      <!--Seat Availability Section-->
      <div class="row mx-0 mt-5 justify-content-center" v-if="seatTypes">
        <div
          class="d-flex justify-content-end align-items-center"
          style="text-align: center;"
        >
          <div class="mx-1 height_cutsom">
            <div
              class="
                  pos-seat
                  my-0
                  regular-seat
                  seat-fixed-width
                  mx-auto
                  bg-blue
                "
            ></div>
            <span style="font-size:12px">Regular {{ $tc("seat", 1) }}</span>
          </div>

          <div class="mx-1 height_cutsom" style="position: relative; top: 2px">
            <div class="text-center mb-1">
              <img
                src="@/assets/img/pos/wheelchair.svg"
                height="auto"
                width="22"
                alt
              />
            </div>
            <span style="font-size:12px">{{ $t("wheelchair") }}</span>
          </div>

          <!-- <div class="mx-1 height_cutsom">
              <div
                class="pos-seat my-0 vip-seat seat-fixed-width mx-auto bg-blue"
              ></div>
              <span style="font-size:12px">VIP {{ $tc("seat", 1) }}</span>
            </div> -->

          <!-- <div class="mx-1">
            <div class="pos-seat my-0 love-seat mx-auto bg-blue"></div>
            <span style="font-size:12px">{{ $t('love') }} {{ $tc('seat', 1) }}</span style="font-size:12px">
            </div>-->

          <div
            class="mx-1 height_cutsom"
            style="position: relative; top: 2px"
            v-if="false"
          >
            <!-- <div class="text-center mb-1">
              <img src="@/assets/img/icons/pointofsale.png" height="auto" width="22" alt />
              </div>-->
            <div class="pos-seat my-0 pointofsale-seat mx-auto bg-blue"></div>
            <span style="font-size:12px">{{ $t("onlyPos") }}</span>
          </div>

          <div class="mx-1 height_cutsom" v-if="false">
            <div
              class="pos-seat my-0 sofa-seat seat-fixed-width mx-auto bg-blue"
            ></div>
            <span style="font-size:12px">{{ $tc("Sofa", 1) }}</span>
          </div>

          <div class="mx-1 height_cutsom" v-if="false">
            <div
              class="
                  pos-seat
                  my-0
                  recliner-seat
                  seat-fixed-width
                  mx-auto
                  bg-blue
                "
            ></div>
            <span style="font-size:12px"
              >{{ $t("recliner") }} {{ $tc("seat", 1) }}</span
            >
          </div>

          <div class="mx-1 height_cutsom" v-if="false">
            <div
              class="pos-seat my-0 block-seat seat-fixed-width mx-auto"
            ></div>
            <span style="font-size:12px">{{ $tc("blockSeat", 1) }}</span>
          </div>

          <div
            class="mx-1 height_cutsom"
            style="position: relative; top: 2px"
            v-if="false"
          >
            <!-- <div class="text-center mb-1">
              <img src="@/assets/img/icons/broken-seat.jpg" height="auto" width="22" alt />
              </div>-->
            <div
              class="
                  pos-seat
                  my-0
                  broken-seat
                  seat-fixed-width
                  mx-auto
                  bg-blue
                "
            ></div>
            <span style="font-size:12px"
              >{{ $t("broken") }} {{ $tc("seat", 1) }}</span
            >
          </div>

          <div class="divider mx-1 height_cutsom"></div>

          <div class="mx-1 height_cutsom">
            <div class="pos-seat my-0 taken seat-fixed-width mx-auto"></div>
            <span style="font-size:12px">{{ $t("taken") }}</span>
          </div>

          <div class="mx-1 height_cutsom">
            <div
              class="pos-seat my-0 your-selection seat-fixed-width mx-auto"
            ></div>
            <span style="font-size:12px"
              >{{ $t("your") }} {{ $t("selection") }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- <b-button v-b-modal.seat_select_modal>Select Seat</b-button> -->
    <b-modal
      hide-footer
      hide-header
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      ref="seat_select_modal"
      id="seat_select_modal"
      class="seat_select_modal"
    >
      <div class="text-center pt-4">
        <h5 class="font-weight-bold text-blue mb-3">
          How many seats you want to book ?
        </h5>
        <ul class="seatNumList list-inline pl-0 mb-0 pt-2">
          <li
            class="list-inline-item"
            v-for="(item, itemKey) in selectSeatPopUpCount"
            :key="itemKey"
            :class="totalNumberOfSeats == item ? 'active' : ''"
            @click="onSelectNumberOfSeats(item)"
          >
            {{ itemKey + 1 }}
          </li>
        </ul>
      </div>
    </b-modal>

    <!--modal- specify seat type-->
    <b-modal
      hide-footer
      hide-header
      hide-backdrop
      no-close-on-backdrop
      ref="specify_seats_modal"
      id="specify_seats_modal"
      class=""
      size="xl"
    >
      <div class="d-flex flex-column">
        <div class="d-flex border-bottom border-dark">
          <div class="col-6">
            <h5 class="font-weight-bold mt-2">Pricing</h5>
          </div>
          <div class="col-6 text-right">
            <button
              class="btn-modal-close ml-auto"
              @click="$bvModal.hide('specify_seats_modal')"
            >
              &times;
            </button>
          </div>
        </div>

        <div
          class="d-flex align-items-center border-bottom flex-wrap"
          v-for="(item, index) in oldSeatLayout"
          :key="index"
        >
          <div
            class="
              seat-type
              gold
              d-flex
              justify-content-center
              align-item-center
            "
            :style="'color:' + item.seats[0].sst_seat_color_code"
          >
            <div class="st-name">{{ item.seatType }}</div>
          </div>
          <div
            class="d-flex align-items-center"
            v-if="item.seats[0].rate_card_group.length > 0"
            v-for="(rcg_group, rcg_index) in item.seats[0].rate_card_group"
            :key="rcg_index"
          >
            <div class="category h-auto">
              <div class="category-name">{{ rcg_group.tt_name }}</div>
              <div class="category-price">
                {{ currencyData.curr_code }} {{ currFormat(rcg_group.rc_total_amount) }}
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center" v-else>
            <div class="category">
              <div class="category-name">Adult</div>
              <div class="category-price">
                {{ currencyData.curr_code }} {{ currFormat(item.seat_price) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <ManagerAuthLogin
      :moduleName="'seatLayout'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_posSeatLayout'"
    />
  </div>
</template>
<script>
  import ScreenService from "@/services/ScreenService";
  import MasterService from "@/services/MasterService";
  import UserService from "@/services/UserService";
  import CovidBlockedSeatIcon from "@/components/Partials/CovidBlockedSeatIcon.vue";
  import { backendSocket } from "@/main.js";
  import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
  import { mapState, mapGetters, mapActions } from "vuex";
  import { EventBus } from "@/main";
  import { multiselectMixin } from "vue-multiselect";

  export default {
    components: {
      CovidBlockedSeatIcon,
      ManagerAuthLogin,
    },
    props: {
      showFullScreen: { type: Function },
      ss_id: { type: Number },
      reverse_screen: { type: Boolean },
      turnOffMultiSeatSelection: { type: String, default: "N" },
    },
    // name: "Pos Seat Layout",
    data() {
      return {
        noAuth: false,
        clickSeatTempData: {
          seat: null,
          rowIndex: null,
          seatIndex: null,
          originalIndex: null,
          backward: null,
          e: null,
          type: null,
        },
        numzoom: window.localStorage.getItem("zoomvalue")
          ? window.localStorage.getItem("zoomvalue")
          : 0.5,
        isDblClick: false,
        showSeatNames: false,
        currencyData: "",
        fullscreen: false,
        reverse: true,
        selectedSeats: [],
        selectionType: "Bulk", //Bulk,
        no_of_seats: 3,
        reservation_id_local: null,

        selectedVipSeatObject: {},
        activeSeatTypes: [],
        seatTypes: [
          {
            seatName: "Regular Seat",
            size: 1,
            value: 1,
            imageClass: "regular-seat",
            imageURL: "",
          },
          {
            seatName: "No Seat",
            size: 1,
            value: 2,
            imageClass: "no-seat",
            imageURL: "",
          },
          {
            seatName: "Wheel Chair",
            size: 1,
            value: 3,
            imageClass: "wheelchair",
            imageURL: "",
          },
          {
            seatName: "VIP Seat",
            size: 1,
            value: 5,
            imageClass: "vip-seat",
            imageURL: "",
          },
          {
            seatName: "Only POS",
            size: 1,
            value: 9,
            imageClass: "pointofsale",
            imageURL: "",
          },
          {
            seatName: "Sofa",
            size: 1,
            value: 10,
            imageClass: "sofa-seat",
            imageURL: "",
          },
          {
            seatName: "Recliner",
            size: 1,
            value: 11,
            imageClass: "recliner",
            imageURL: "",
          },
          {
            seatName: "Broken Seat",
            size: 1,
            value: 13,
            imageClass: "broken-seat",
            imageURL: "",
          },
        ],
      };
    },
    computed: {
      isMultiSelectAllowed: {
        get() {
          return this.$store.getters.isMultiSelectAllowed;
        },
        set(value) {
          this.$store.dispatch("onChangeMultiSelectSwitch", value);
        },
      },
      selectSeatPopUpCount() {
        return parseInt(this.$store.getters.seatCountPopUp);
      },
      seatType() {
        console.log(this.$store.getters.SEAT_LAYOUT_DATA, "seatLayout");
        return this.$store.getters.SEAT_LAYOUT_DATA;
      },
      MANAGER_AUTH_FOR_CHANGES() {
        return this.$store.getters.MANAGER_AUTH_FOR_CHANGES;
      },
      oldSeatLayout() {
        return this.$store.getters.GET_OLD_SEAT_LAYOUT;
      },
      scheduleShowId() {
        return this.$store.getters.SCHEDULE_SHOW_ID;
      },
      getScreenPosNames() {
        return this.$store.getters.getScreenPosNames;
      },
      SelectedSeats() {
        return this.$store.getters.SELECTED_SEATS;
      },
      totalNumberOfSeats() {
        return this.$store.getters.totalNumberOfSeats;
      },
    },
    sockets: {
      connect: function() {
        console.log("socket connected");
      },
      setMainSeatLayout: function(flag) {
        this.fullscreen = flag;
        this.showFullScreen();
      },
      seatSelection: async function(data) {
        // this.scheduleShowId = data.scheduleShowId;
        await this.$store.dispatch("SET_SCHEDULE_SHOW_ID", data.scheduleShowId);
        await this.SocketHandlerSeatSelected(
          data.seat,
          data.rowIndex,
          data.seatIndex,
          data.originalIndex,
          data.backward,
          data.e,
          data.type
        );
      },
    },
    mounted() {
      this.reverse = this.reverse_screen;
      this.getCurrencyCode();
      let obj = this.secureStore.get("USINFO").cinema_id;
      this.getCinemaDetails(obj);
      this.fetchFnBItems();
      // this.$store.dispatch("NO_OF_SEATS", no_of_seats);

      // create a new reservation and set it each time the seat layout page loads
      let reservation_id = Math.floor(100000000 + Math.random() * 900000000);
      this.$store.commit("SET_RESERVATION_ID_TEMP", reservation_id);
      this.$store.dispatch("ResetCardTrxDetails");

      if (backendSocket && backendSocket.connected) {
      
        backendSocket.emit("joined-seat-layout", {
          ss_id: this.ss_id,
        });

        backendSocket.on("seat-layout-changes", (payload) => {
          let { sl_id, status } = payload;
          
          this.$store.commit("UPDATE_SEAT_LAYOUT", {
            sl_id,
            status,
          });
        });

        backendSocket.on("select-seat-response", (res) => {
          if (!res.status) {
            console.log("select-seat-response status false: ", res);

            let reservation_id = Math.floor(
              100000000 + Math.random() * 900000000
            );
            this.$store.commit("SET_RESERVATION_ID_TEMP", reservation_id);

            this.$toasted.show(res.message);
            console.log(
              this.$store.getters.SHOW_DETAILS,
              "this.$store.getters.showDetails select-seat-response line 905"
            );
            this.$store.dispatch(
              "GET_SEAT_LAYOUT",
              this.$store.getters.SHOW_DETAILS
            );
            this.$store.commit(
              "NUMBER_OF_SEATS",
              this.$store.getters.totalNumberOfSeats
            );
          }
        });
      }
    },
    beforeDestroy() {
      if (backendSocket) {
        backendSocket.off("seat-layout-changes");
        backendSocket.off("select-seat-response");
      }
    },

    methods: {
      // POS OFFERS SAIF START
      ...mapActions([
        "getCinemaDetails",
        "fetchOffersList",
        "fetchFnBItems",
        "onSetSelectedOfferId",
        "fetchOffersVouchersList",
        "SelectNumberOfSeats",
        "onResetOffersAndPrice",
      ]),
      onCheckAuthentication(response) {
        const { valid, name } = response;
        console.log("valid", valid);
        console.log("name", name);
        if (valid) {
          if (name == "seatLayout") {
            this.noAuth = true;
            const {
              seat,
              rowIndex,
              seatIndex,
              originalIndex,
              backward,
              e,
              type,
            } = this.clickSeatTempData;
            this.onClickSeat(
              seat,
              rowIndex,
              seatIndex,
              originalIndex,
              backward,
              e,
              type
            );
            this.$bvModal.hide("authManager_posSeatLayout");
          }
        }
      },
      isWheelChairOnlyRow(SeatTypeArray = []) {
        let statusCount = 0;

        SeatTypeArray.forEach((row) => {
          row.forEach((x) => {
            if (x.seat_reserve_type_id != 2 && x.seat_reserve_type_id != 3) {
              statusCount++;
            }
          });
        });

        if (statusCount > 0) {
          return false;
        } else {
          return true;
        }
      },
      onmouseScroll(e) {
        // this.isDblClick = this.isDblClick;
        if (e.wheelDeltaY > 0 && this.numzoom < 1.2) {
          this.numzoom = this.numzoom + 0.1;
        }
        if (e.wheelDeltaY < 0 && this.numzoom > 0.5) {
          this.numzoom = this.numzoom - 0.1;
        }
        window.localStorage.setItem("zoomvalue", this.numzoom);
      },
      pluszoom(pluszoom) {
        console.log("in fn");
        if (pluszoom == "plus" && this.numzoom < 1.2) {
          this.numzoom = +parseFloat(this.numzoom + 0.1).toFixed(3);
          console.log(this.numzoom, "Double click plus");
        }
        if (pluszoom == "minus" && this.numzoom > 0.5) {
          this.numzoom = +parseFloat(this.numzoom - 0.1).toFixed(3);
          console.log(this.numzoom, "Double click minus");
        }
        window.localStorage.setItem("zoomvalue", this.numzoom);
      },
      dblClick() {
        return;
        // this.isDblClick = !this.isDblClick;
        // console.log("Double CLick")
      },
      checkAlreadyBlocked(seat) {
        if (seat.seat_reserve_type_id == 8 && !seat.selectStatus) {
          return false;
        } else if (
          seat.seat_reserve_type_id == 8 &&
          seat.selectStatus == true
        ) {
          return true;
        } else {
          return true;
        }
      },
      getSeatTypes: function(screen) {
        let payload = {
          tableName: "ms_seat_reserve_types",
          srt_is_active: "Y",
        };
        this.seatTypes = [];
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.activeSeatTypes = data.Records;
              this.activeSeatTypes.map((x) => {
                let obj = {
                  seatName: x.srt_name,
                  size: x.srt_seat_capacity,
                  value: x.srt_id,
                  imageClass: "regular-seat",
                  imageURL: this._GetImagePath(x.srt_dash_image_url),
                };
                this.seatTypes.push(obj);
              });
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            console.log("Catch Error :", error);
          });
      },
      getSeatIconURL(singleSeat) {
        let iconPath = ``;
        if (singleSeat.selectStatus) {
          iconPath = this._GetImagePath(singleSeat.srt_dash_image_url_selected);
        } else if (
          singleSeat.seat_reserve_type_id == 12 ||
          singleSeat.seat_reserve_type_id == 8
        ) {
          iconPath = this._GetImagePath(singleSeat.srt_dash_image_url_disabled);
        } else {
          iconPath = this._GetImagePath(singleSeat.srt_dash_image_url);
        }
        // this.$forceUpdate();
        return iconPath;
      },
      // POS OFFERS SAIF END
      onChangeMultiSelectSeats(event) {
        this.$store.dispatch("onResetFnBStoreState");
        if (!event) {
          this.onSelectNumberOfSeats(1);
        } else if (this.totalNumberOfSeats) {
          this.onSelectNumberOfSeats(this.totalNumberOfSeats);
        } else {
          this.onSelectNumberOfSeats(1);
        }
      },
      getCurrencyCode: function() {
        let payload = {
          tableName: "ms_currencies",
          curr_is_active: "Y",
          curr_id:
            this.secureStore.get("BRGLOPCU") &&
            this.secureStore.get("BRGLOPCU").go_value,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.currencyData = data.Records[0];
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getActiveScreenByCinemaId :", error);
          });
      },
      showFullScreenFunc: function() {
        this.showFullScreen();
      },
      onSelectNumberOfSeats: function(number) {
        this.$refs.seat_select_modal.hide();
        if (this.$socket) {
          this.$socket.emit("set_numbers_of_seats", {
            number,
          });
        }
        this.SelectNumberOfSeats(number);
        this.$store.dispatch("onResetFnBStoreState");
      },
      getSeatLayout: function() {
        // let payload = {};
        // ScreenService.getSeatLayout(payload);
      },
      // openSpecifyModal : function() {
      //   this.$refs.specify_seats_modal.show();
      // },
      SocketHandlerSeatSelected: async function(
        seat,
        rowIndex,
        seatIndex,
        originalIndex,
        backward,
        e,
        type
      ) {
        await this.onSetSelectedOfferId({
          name: "isSeatType",
          id: seat.sst_id,
        });
        // await this.fetchOffersList({ seat_type_id: seat.sst_id });

        seat.seatIndex = seatIndex;
        seat.rowIndex = rowIndex;
        this.$store.dispatch("SEAT_SELECTION", {
          seat: seat,
          seatIndex: seatIndex,
          rowIndex: rowIndex,
          classIndex: type,
          scheduleShowId: this.scheduleShowId,
        });
      },
      onClickSeat(seat, rowIndex, seatIndex, originalIndex, backward, e, type) {
        let self = this;
        console.log(
          "COMING TO onClickSeat",
          this.MANAGER_AUTH_FOR_CHANGES,
          this.noAuth
        );
        if ([2, 12, 13].includes(seat.seat_reserve_type_id)) {
          this.$toasted.show("Not Available");
          return false;
        } else if (
          this.MANAGER_AUTH_FOR_CHANGES == "Y" &&
          !this.noAuth &&
          [4].includes(seat.seat_reserve_type_id)
        ) {
          let tempObj = {
            seat,
            rowIndex,
            seatIndex,
            originalIndex,
            backward,
            e,
            type,
          };
          console.log("tempObj", tempObj);
          Object.keys(this.clickSeatTempData).map((key) => {
            this.clickSeatTempData[key] = tempObj[key];
          });
          console.log(this.clickSeatTempData, "this.clickSeatTempData");
          this.$bvModal.show("authManager_posSeatLayout");
        } else if (
          seat.srt_multi_select == "Y" &&
          this.turnOffMultiSeatSelection != "Y" &&
          seat.sl_group_id
        ) {
          let groupSeatsIndexes = [];
          groupSeatsIndexes = this.seatType[type].seatsFinal[rowIndex].reduce(
            function(a, e, i) {
              if (
                e.sl_group_id == seat.sl_group_id &&
                ![2, 12, 13].includes(e.seat_reserve_type_id) &&
                self.checkAlreadyBlocked(e)
              )
                a.push(i);
              return Array.from(new Set(a));
            },
            []
          );

          console.log("groupSeatsIndexes", groupSeatsIndexes);

          if (groupSeatsIndexes && groupSeatsIndexes.length > 0) {
            this.handlerSeatSelected(
              this.seatType[type].seatsFinal[rowIndex][seatIndex],
              rowIndex,
              seatIndex,
              originalIndex,
              backward,
              e,
              type,
              groupSeatsIndexes
            ).finally((_) => {});
          } else {
            this.handlerSeatSelected(
              seat,
              rowIndex,
              seatIndex,
              originalIndex,
              backward,
              e,
              type
            ).finally((_) => {});
          }
        } else {
          this.handlerSeatSelected(
            seat,
            rowIndex,
            seatIndex,
            originalIndex,
            backward,
            e,
            type
          );
        }
      },
      handlerSeatSelected: async function(
        seat,
        rowIndex,
        seatIndex,
        originalIndex,
        backward,
        e,
        type,
        srt_group_array = []
      ) {
        EventBus.$emit("checkPopupExist", false);
        console.log(
          "seat, ",
          seat,
          rowIndex,
          seatIndex,
          originalIndex,
          backward,
          e,
          type
        );

        let payload = {
          seat,
          rowIndex,
          seatIndex,
          originalIndex,
          backward,
          e,
          type,
          srt_group_array,
        };
        await this.onResetOffersAndPrice();
        if (seat.item_id && String(seat.item_id).length > 0) {
          let cinema_id =
            this.secureStore.get("USINFO") &&
            this.secureStore.get("USINFO").cinema_id;
          if (!this.isMultiSelectAllowed) {
            if (
              this.seatType[type].seatsFinal[rowIndex][seatIndex]
                .selectStatus == false
            ) {
              this.$store.dispatch("GET_FNB_PRICING", {
                item_id: seat.item_id,
                item_is_compulsory: seat.item_is_compulsory || "N",
                cinema_id,
                noReset: true,
                multipleSeatCapacity: srt_group_array.length || 1,
              });
            } else if (
              this.seatType[type].seatsFinal[rowIndex][seatIndex]
                .selectStatus == true
            ) {
              this.$store.dispatch("onDecreaseFnBItem", { index: 0 });
            }
          } else {
            this.$store.dispatch("GET_FNB_PRICING", {
              item_id: seat.item_id,
              item_is_compulsory: seat.item_is_compulsory || "N",
              cinema_id,
            });
          }
        } else {
          // this.$store.dispatch("onResetFnBStoreState");
        }

        if (!this.isMultiSelectAllowed) {
          // await this.$store.dispatch("SEAT_SELECTION", {
          //   seat: seat,
          //   seatIndex: seatIndex,
          //   rowIndex: rowIndex,
          //   classIndex: type,
          //   reservation_id: Math.floor(100000000 + Math.random() * 900000000),
          //   schedule_show_id: this.scheduleShowId,
          // });
          await this.$store.dispatch("seatHandler", payload);
        } else {
          await this.$store.dispatch("seatHandler", payload);
        }

        if (this.$socket) {
          setTimeout(() => {
            // console.log(this.SelectedSeats, "fsdfsdfsdfsdfdsf");
          });
          this.$socket.emit("select_seats_from_brij", this.SelectedSeats);
        }
        await this.onSetSelectedOfferId({
          name: "isSeatType",
          id: seat.sst_id,
        });

        // await this.fetchOffersList({ seat_type_id: seat.sst_id });
        // await this.fetchOffersVouchersList({ seat_type_id: seat.sst_id });
      },
    },
  };
</script>

<style scoped>
  /* .hideScreen {
  height: 0;
  opacity: 0;
  overflow: hidden;
  visibility: hidden;
  margin-bottom: 0 !important;
} */
  .normal-seat {
    display: none !important;
  }

  .seatNumList li {
    height: 35px;
    width: 35px;
    color: #ffffff;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    border-radius: 50%;
    align-items: center;
    display: inline-flex;
    justify-content: center;
    background-color: #979797;
    transition: transform 0.25s;
  }

  .seatNumList li.active,
  .seatNumList li:hover {
    background-color: #3876d2;
  }

  /*@media (min-width: 992px) {*/

  /* .seat_select_modal .modal-lg{*/
  /*  max-width: 1030px;*/
  /*  background-color: white;*/
  /*  } */

  /*}*/

  .seatNumList li:active {
    transform: scale(0.85);
  }

  .seat-type {
    padding: 1rem;
    min-width: 200px;
    height: 115px;
    font-weight: bold;
  }

  .seat-type.gold {
    background-color: #f9f9f9;
    color: #f2c94c;
  }

  .seat-type.silver {
    background-color: #efefef;
    color: #a8a8a8;
  }

  .seat-type .st-name {
    font-weight: bold;
    font-size: 2.5rem;
    border-bottom: 1px solid #bfbfbf;
    margin-bottom: 0.25rem;
    word-break: break-all;
  }

  .category {
    display: flex;
    flex-direction: column;
    width: 180px;
    height: 160px;
    background-color: #efefef;
    color: black;
    text-align: center;
    margin: 1rem;
    border-radius: 0.5rem;
  }
  .category.disabled {
    background-color: #f9f9f9;
    color: #999999;
  }
  .category.disabled .mod-btn {
    background-color: #afc8ed;
  }
  .category .category-name {
    font-size: 1.5rem;
    font-weight: 500;
    height: 53px;
    text-align: center;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .category .category-price {
    font-size: 1.5rem;
    font-weight: 500;
    height: 53px;
    text-align: center;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .category .category-seats {
    font-weight: bold;
    font-size: 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-top: 1px solid #bfbfbf;
    padding: 0.25rem;
    width: 100%;
    color: black;
    user-select: none;
  }
  .category .category-seats .mod-btn {
    font-weight: bold;
    font-size: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    color: white;
    background-color: #3876d2;
    height: 40px;
    width: 40px;
    border-radius: 0.25rem;
    cursor: pointer;
    transition: all 0.4s;
    user-select: none;
  }
  .category .category-seats .mod-btn:hover {
    color: #3876d2;
    background-color: white;
  }
  .category .category-seats .mod-btn:active {
    transform: scale(0.8);
  }

  .fl.btn-blue {
    font-size: 20px !important;
    padding: 1.5rem 2rem;
  }

  #specify_seats_modal .seat-type {
    min-width: 292px !important;
  }

  #specify_seats_modal .category {
    width: 223px !important;
  }

  #specify_seats_modal .category .category-name {
    line-break: anywhere !important;
  }

  #specify_seats_modal .btn-modal-close {
    position: absolute;
    top: -7px !important;
    right: -8px !important;
  }
  .change_screen {
    transform: rotateX(180deg);
  }
  .pos-seatlayout-rotate {
    transform: scale(1, -1);
  }
  .pos-seatlayout-rotate-text {
    transform: scale(1, -1);
  }
  .large {
    transform: scale(1.2);
  }
  .height_cutsom {
    height: 75px;
  }
  .seatTypetext {
    width: 100%;
    font-weight: bold;
    font-size: 16px;
    padding: 8px 0px 8px 0px;
    text-align: center;
    letter-spacing: 1px;
    text-decoration: underline;
    /* border-bottom: 1px solid #000; */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .wheel_img {
    background-color: grey;
  }
  .seat_avail_sec span {
    font-size: 16px;
    font-weight: bold;
  }
  .avail_box {
    border: 0.5px solid #000;
    width: 30px;
    border-radius: 6px;
    background-color: transparent;
  }
  .block_seat {
    width: 30px;
    border-radius: 6px;
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posSeatLayout.vue